<template>
    <div class="card">
        <div class="card-header bg-white">
            <div class="d-flex justify-content-between align-items-center">
                <h3 class="text-5 font-weight-400 mb-3">Change your password</h3>
                <router-link to="/profile" class="shadow-none btn btn-outline-primary btn-sm"><i
                    class="fa fa-user-circle mr-1"></i>View profile
                </router-link>
            </div>
        </div>
        <div class="card-body">
            <div v-if="message" class="bg-primary-dark text-white text-center p-2">
                {{ message }}
            </div>
            <div class="col-lg-6">

                <div class="row py-2">
                    <p class="col-12 text-muted mb-0 mb-sm-3">Old Password</p>
                    <div class="col-12">
                        <input type="password" v-model="form.old_password" value=""
                               :class="[ 'form-control' , form.errors.get('old_password') ? 'is-invalid' : '' ]">
                        <div v-text="form.errors.get('old_password')" class="invalid-feedback"/>
                    </div>
                </div>
                <div class="row py-2">
                    <p class="col-12 text-muted mb-0 mb-sm-3">New Password</p>
                    <div class="col-12">
                        <input type="password" v-model="form.password" value=""
                               :class="[ 'form-control' , form.errors.get('password') ? 'is-invalid' : '' ]">
                        <div v-text="form.errors.get('password')" class="invalid-feedback"/>
                    </div>
                </div>
                <div class="row py-2">
                    <p class="col-12 text-muted mb-0 mb-sm-3">Repeat Password</p>
                    <div class="col-12">
                        <input type="password" v-model="form.password_confirmation" value=""
                               :class="[ 'form-control' , form.errors.get('password_confirmation') ? 'is-invalid' : '' ]">
                        <div v-text="form.errors.get('password_confirmation')" class="invalid-feedback"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer bg-white">
            <button @click="update" :class="['btn btn-primary' ,  form.loading ? 'btn-loading' : '']">Update
                Password
            </button>
        </div>
    </div>
</template>

<script>
import Form from "../../core/forms/form";

export default {
    name: "profile",
    methods: {
        init() {
            this.loading = true;
            window.axios.get(`${window.location.origin}/admin/auth`).then((response) => {
                this.model = response.data.body.model;
                this.form.extract(this.model);
            }).finally(() => {
                this.loading = false;
            });
        },

        update() {
            window.Swal.fire({
                title: 'Are you sure ?',
                text: `You want to update your password`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#22568C',
                cancelButtonColor: '#d33',
                confirmButtonText: `Yes, Update!`
            }).then((result) => {
                if (result.value) {
                    this.form.submit('/admin/password').then((response) => {
                        this.message = "Your password was successfully updated";
                        this.form.reset();
                    }).catch((error) => {
                    });
                }
            });
        }
    },
    mounted() {
        this.init();
    },
    data() {
        return {
            model: {},
            message: null,
            form: new Form({
                old_password: '',
                password: '',
                password_confirmation: '',
            })
        };
    }

}
</script>

<style scoped>

</style>
